import React, { Component } from 'react';
import ActionButton from './ActionButton';

/**
 * Reusable project tile. Shows the project bubble + title and a list of the
 * last few edited chapters underneath. The chapter list is rendered as
 * sibling buttons (not nested inside the project button) to keep markup
 * valid.
 *
 * Props:
 * - project: { id, title, recent_chapters?: [{ id, title, updated_at }] }
 * - isActive: boolean
 * - onSelect: (project) => void
 * - onSelectChapter: (project, chapter) => void
 * - recentLimit: number (default 3)
 */
class ProjectTile extends Component {
  static defaultProps = {
    isActive: false,
    recentLimit: 3,
  };

  handleSelect = () => {
    this.props.onSelect?.(this.props.project);
  };

  handleSelectChapter = (chapter) => (e) => {
    e?.stopPropagation?.();
    this.props.onSelectChapter?.(this.props.project, chapter);
  };

  renderRecentChapters() {
    const { project, recentLimit } = this.props;
    const chapters = Array.isArray(project?.recent_chapters)
      ? project.recent_chapters.slice(0, recentLimit)
      : [];

    if (chapters.length === 0) return null;

    return (
      <fieldset className="recent-chapters">
        <legend className="recent-chapters__legend">Last edited</legend>
        <ul className="recent-chapters__list" aria-label={`Recent chapters in ${project.title}`}>
          {chapters.map((c) => {
            const title = c.title || 'Untitled chapter';
            const num = c.chapter_number;
            const hasNum = num !== null && num !== undefined && num !== '';
            const label = hasNum ? `Ch ${num}. ${title}` : title;
            return (
              <li key={c.id} className="recent-chapters__item">
                <ActionButton
                  className="recent-chapters__link"
                  onClick={this.handleSelectChapter(c)}
                  title={label}
                  ariaLabel={`Open chapter ${label}`}
                >
                  {hasNum && <span className="recent-chapters__num">Ch {num}.</span>}
                  <span className="recent-chapters__title">{title}</span>
                </ActionButton>
              </li>
            );
          })}
        </ul>
      </fieldset>
    );
  }

  render() {
    const { project, isActive } = this.props;
    const initial = (project.title?.[0] || 'P').toUpperCase();

    return (
      <div className={`project-tile ${isActive ? 'active' : ''}`}>
        <ActionButton
          className={`story-item ${isActive ? 'active' : ''}`}
          onClick={this.handleSelect}
          title={project.title}
          ariaLabel={`Open project ${project.title}`}
        >
          <span className="story-ring">
            <span className="story-bubble">{initial}</span>
          </span>
          <span className="story-title">{project.title}</span>
        </ActionButton>
        {this.renderRecentChapters()}
      </div>
    );
  }
}

export default ProjectTile;
